import type { Vector2 } from "~/state/game-types";
import type { TerrainGeneratorConfig } from "~/terrain/terrain-generation";
import type { TerrainGenerationWorkerEvents } from "~/terrain/terrain-generation.worker";
import { WorkerClient } from "~/utils/workers";

export class TerrainGeneratorClient {
  constructor(private readonly config: TerrainGeneratorConfig) {}

  private workerClientPromise?: Promise<
    WorkerClient<TerrainGenerationWorkerEvents>
  >;

  public async generateChunkTerrainAsync(
    chunkPlacement: Vector2,
  ): Promise<Uint8Array> {
    if (!this.workerClientPromise) {
      // Vite only bundles the worker when `new URL` is written inline here with
      // a static relative path. Hoisting it into a variable, or using a `~/`
      // alias, ships the raw TS source in production builds.
      const workerClient = new WorkerClient<TerrainGenerationWorkerEvents>(
        () =>
          new Worker(
            new URL("./terrain-generation.worker.ts", import.meta.url),
            {
              type: "module",
            },
          ),
      );
      this.workerClientPromise = workerClient
        .postWorkerEvent("init", { config: this.config })
        .then(() => workerClient);
    }

    const workerClient = await this.workerClientPromise;

    const { terrainTypesBuffer } = await workerClient.postWorkerEvent(
      "generateChunkTerrain",
      { chunkPlacement },
    );
    return terrainTypesBuffer;
  }

  public dispose(): void {
    // Clean up if needed

    void this.workerClientPromise?.then((workerClient) =>
      workerClient.postWorkerEvent("dispose", undefined),
    );
  }
}
